import * as Types from '../Constants/AllConstants';

export const FileUploadReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.UPLOAD_FILE_REQUEST:
      return { loading: true };
    case Types.UPLOAD_FILE_SUCCESS:
      return { loading: false, success: true, file: action.payload };
    case Types.UPLOAD_FILE_FAIL:
      return { loading: false, error: action.payload };
    case Types.UPLOAD_FILE_RESET:
      return {};
    default:
      return state;
  }
};

export const FileDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.DELETE_FILE_REQUEST:
      return { loading: true };
    case Types.DELETE_FILE_SUCCESS:
      return { loading: false, success: true };
    case Types.DELETE_FILE_FAIL:
      return { loading: false, error: action.payload };
    case Types.DELETE_FILE_RESET:
      return {};
    default:
      return state;
  }
};

export const CreateDirectoryReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.CREATE_DIRECTORY_REQUEST:
      return { loading: true };
    case Types.CREATE_DIRECTORY_SUCCESS:
      return { loading: false, success: true, directory: action.payload };
    case Types.CREATE_DIRECTORY_FAIL:
      return { loading: false, error: action.payload };
    case Types.CREATE_DIRECTORY_RESET:
      return {};
    default:
      return state;
  }
};

export const FileDownloadReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.DOWNLOAD_FILE_REQUEST:
      return { loading: true };
    case Types.DOWNLOAD_FILE_SUCCESS:
      return { loading: false, success: true };
    case Types.DOWNLOAD_FILE_FAIL:
      return { loading: false, error: action.payload };
    case Types.DOWNLOAD_FILE_RESET:
      return {};
    default:
      return state;
  }
};

